module.exports = __webpack_public_path__ + "img/currencyEle.f2373b29.svg";